import { render, staticRenderFns } from "./wxsignin.vue?vue&type=template&id=b4b5ea12"
import script from "./wxsignin.vue?vue&type=script&lang=js"
export * from "./wxsignin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports